module.exports = __webpack_public_path__ + "img/neid.434c521d.png";